import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import i18n from './i18n'; // Import i18n
import '@fortawesome/fontawesome-free/css/all.css';

const app = createApp(App);

app.use(router); // Use the router
app.use(i18n); // Use i18n

const localStorageLang = localStorage.getItem('language');
const cookieLang = document.cookie.replace(/(?:(?:^|.*;\s*)language\s*=\s*([^;]*).*$)|^.*$/, "$1");
const browserLang = navigator.language.split('-')[0];

// Priority: localStorage > cookie > browser setting > default
let selectedLang = 'en'; // Default

if (localStorageLang && ['en', 'uk', 'pl'].includes(localStorageLang)) {
  selectedLang = localStorageLang;
} else if (cookieLang && ['en', 'uk', 'pl'].includes(cookieLang)) {
  selectedLang = cookieLang;
} else if (['en', 'uk', 'pl'].includes(browserLang)) {
  selectedLang = browserLang;
} 

i18n.global.locale = selectedLang;

// Also set localStorage for consistency
if (!localStorageLang) {
  localStorage.setItem('language', selectedLang);
}


app.mount('#app');

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token'); // Check if user is authenticated
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Login' }); // Redirect to login if not authenticated
  } else {
    next(); // Proceed to the route
  }
});